import { forwardRef } from "react";

export * from "@heroicons/react/24/solid";

export const ImagePlusIcon = (props) => {
	return (
		<svg
			{...props}
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5.33317 6.66667H22.6665V16H25.3332V6.66667C25.3332 5.196 24.1372 4 22.6665 4H5.33317C3.8625 4 2.6665 5.196 2.6665 6.66667V22.6667C2.6665 24.1373 3.8625 25.3333 5.33317 25.3333H15.9998V22.6667H5.33317V6.66667Z"
				fill="currentColor"
			/>
			<path
				d="M10.6665 14.6667L6.6665 20H21.3332L15.9998 12L11.9998 17.3333L10.6665 14.6667Z"
				fill="currentColor"
			/>
			<path
				d="M25.3332 18.6667H22.6665V22.6667H18.6665V25.3333H22.6665V29.3333H25.3332V25.3333H29.3332V22.6667H25.3332V18.6667Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export const CrownIcon = (props) => {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 576 512"
			fill="currentColor"
		>
			<path d="M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z" />
		</svg>
	);
};

export const FloppyDiskIcon = (props) => {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 448 448"
			fill="currentColor"
		>
			<path d="M 64.2 0.2 C 28.9 0.2 0.2 28.9 0.2 64.2 V 384.2 c 0 35.3 28.7 64 64 64 H 384.2 c 35.3 0 64 -28.7 64 -64 V 141.5 c 0 -17 -6.7 -33.3 -18.7 -45.3 L 352.2 18.9 C 340.2 6.9 323.9 0.2 306.9 0.2 H 64.2 z m 0 96 c 0 -17.7 14.3 -32 32 -32 H 288.2 c 17.7 0 32 14.3 32 32 v 64 c 0 17.7 -14.3 32 -32 32 H 96.2 c -17.7 0 -32 -14.3 -32 -32 V 96.2 z M 224.2 384.2 c -35.3 0 -64 -28.7 -64 -64 s 28.7 -64 64 -64 s 64 28.7 64 64 s -28.7 64 -64 64 z" />
		</svg>
	);
};

export const ArrowReturnRightIcon = (props) => {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 16 16"
			fill="currentColor"
		>
			<path
				fill-rule="evenodd"
				d="M1.5 1.5A.5.5 0 0 0 1 2v4.8a2.5 2.5 0 0 0 2.5 2.5h9.793l-3.347 3.346a.5.5 0 0 0 .708.708l4.2-4.2a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 8.3H3.5A1.5 1.5 0 0 1 2 6.8V2a.5.5 0 0 0-.5-.5z"
			/>
		</svg>
	);
};

export const PiggyBankIcon = (props) => {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 512 512"
			fill="currentColor"
		>
			<g>
				<path d="m497 256.641h-31.512c-10.983-23.219-28.02-44.363-49.889-61.89v-67.71c0-8.284-6.716-15-15-15-29.757 0-57.731 11.588-78.771 32.628-1.58 1.58-3.115 3.21-4.6 4.886-17.306-3.573-35.154-5.381-53.196-5.381-95.168 0-205.283 58.015-215.117 160.67h-1.799c-9.438 0-17.117-7.679-17.117-17.117v-.016c0-8.284-6.716-14.992-15-14.992s-15 6.724-15 15.008c0 25.98 21.137 47.117 47.117 47.117h1.863c4.02 39.199 23.756 75.608 56.775 104.476l-8.843 33.003c-2.142 7.995 2.604 16.228 10.606 18.371l77.597 20.792c8.011 2.145 16.231-2.618 18.372-10.607l5.743-21.438h109.609l5.743 21.438c3.053 11.388 14.476 11.652 18.371 10.607l77.597-20.792c7.995-2.141 12.751-10.368 10.607-18.371l-8.846-33.011c18.632-16.34 33.341-35.52 43.16-56.271h31.53c8.284 0 15-6.716 15-15v-96.4c0-8.284-6.716-15-15-15zm-208.866-47.774h-64.267c-8.284 0-15-6.716-15-15s6.716-15 15-15h64.267c8.284 0 15 6.716 15 15s-6.716 15-15 15zm95.333 63.2c0 8.284-6.716 15-15 15s-15-6.716-15-15v-16.067c0-8.284 6.716-15 15-15s15 6.716 15 15z" />
				<ellipse
					cx="256"
					cy="55.167"
					rx="55.167"
					ry="55.167"
					transform="matrix(.973 -.23 .23 .973 -5.826 60.292)"
				/>
			</g>
		</svg>
	);
};

export const OccupationIcon = (props) => {
	return (
		<svg
			{...props}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			fill="currentColor"
		>
			<path d="m9 10c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z" />
			<path d="m4.75 12c-2.62 0-4.75 2.13-4.75 4.75v3.5c0 .41.34.75.75.75h9.25v-3.25c0-1.88 1.4-3.43 3.21-3.7.26-.76.75-1.4 1.38-1.86-1-.286-1.054-.19-9.84-.19z" />
			<path d="m22.25 16h-1.25v-.75c0-.965-.785-1.75-1.75-1.75h-2.5c-.965 0-1.75.785-1.75 1.75v.75h-1.25c-.492 0-.935.205-1.253.533l5.503 2.871 5.503-2.871c-.318-.328-.761-.533-1.253-.533zm-5.75 0v-.75c0-.138.112-.25.25-.25h2.5c.138 0 .25.112.25.25v.75z" />
			<path d="m18.347 20.915c-.217.113-.477.113-.693 0l-5.654-2.95v4.285c0 .965.785 1.75 1.75 1.75h8.5c.965 0 1.75-.785 1.75-1.75v-4.285z" />
		</svg>
	);
};
